import React, {Component} from 'react'
import {Row, Col} from 'react-flexbox-grid'

import './jobs-styles.css'

import ReactGA from 'react-ga';
ReactGA.initialize('UA-110112779-1');
ReactGA.pageview(window.location.pathname + window.location.search);

var Parse = require('parse');

export default class JobDescription extends Component {

  constructor(props){
    super(props)

    Parse.initialize(process.env.REACT_APP_API_KEY)
    Parse.serverURL = process.env.REACT_APP_API_URL

    this.state = {
      loading:true
    }
    this.fetchJob()
  }

  fetchJob(){
    let thisState = this
    let JobObject = Parse.Object.extend("JobRole")
    let job = new JobObject()
    job.id = window.location.search.substr(1)
    job.fetch().then(fetchedJob =>{
      if (fetchedJob.get('filled') === true){
        this.props.history.push("/404");
      }else{
        thisState.updateJob(fetchedJob)
      }
    }).catch(error => {
      if (error.code === 101) {
        this.props.history.push("/404");
      }
    })
  }

  updateJob(job){
    let requirements = job.get("requirements").map(req => {
      return <li>{req}</li>
    })
    this.setState({
      loading:false,
      title:job.get("title"),
      location:job.get("location"),
      requirements: requirements,
      summary: job.get("summary")
    })
  }

  render(){
    var description =   <Col xs={10}>
      <h4>Location:</h4>
      <ul><li>{this.state.location}</li></ul>
      <h4>Job Summary</h4>
      <ul>
        <li>{this.state.summary}</li>
      </ul>
      <h4>Qualifications:</h4>
      <ul>
        {this.state.requirements}
      </ul>
      <p>To apply for this position, please send an email with your resumé to <a href={'mailto:contact@universitygo.co?subject=Job%20Application: '+this.state.title}>contact@universitygo.co</a>.</p>
    </Col>

    return(
      <div className='jobDescriptionContainer'>
        <Row center='xs' >
          {this.state.loading ? <h1 className='notExistHeader'>Loading...</h1> : <div><h1 className='notExistHeader'>{this.state.title}</h1></div>}
        </Row>
        <Row around='xs'>
          <Col xs={24} md={6}>{this.state.loading ? null: description}</Col>
        </Row>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Views/Jobs/JobDescription.js